<template>
<v-app>
  <div id="app" class="container-fluid">
    <div v-if="is_logged">
      <admin-layout/>
    </div>
    <div v-else >
      <login-screen />
    </div>
  </div>
</v-app>
</template>

<script>
import { mapState } from 'vuex';
import LoginScreen from './components/LoginScreen'
import AdminLayout from './components/AdminLayout'
export default {
  name: 'app',
  components: {
    LoginScreen,
    AdminLayout
  },
  data: function() {
    return { 
      rememberme:false 
    }
  },
  computed: mapState({
      is_logged: state =>  { console.log('is_logged',state); return (state.username !=null && state.password !=null && state.server !=null) }
  }),  
}
</script>

<style>
:root {
  --buebchen-blue: #00aeef;
  --primary-dark: #111827;
  --secondary-dark: #1f2a3d;
  --navy-strong: #0d1b2a;
  --surface: #ffffff;
  --surface-soft: #f4f7fb;
  --surface-muted: #edf3f8;
  --border-color: #dfe7f1;
  --text-primary: #1d2736;
  --text-secondary: #5e6d82;
  --shadow-soft: 0 12px 28px rgba(16, 24, 40, 0.08);
}

html, body {
  margin: 0;
  min-height: 100%;
  background: linear-gradient(180deg, #edf3f8 0%, #f7fafc 100%);
  color: var(--text-primary);
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  margin-top: 60px;
  min-height: calc(100vh - 60px);
  background: transparent;
}

#app .container-fluid {
  background: transparent;
}

.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}

.btn-primary {
  background: linear-gradient(135deg, var(--buebchen-blue) 0%, #0d9ad0 100%);
  border-color: var(--buebchen-blue);
}

.btn-primary:hover,
.btn-primary:focus {
  background: linear-gradient(135deg, #0d9ad0 0%, #0a7db6 100%);
  border-color: #0d9ad0;
}

.card,
.table,
.form-control,
.form-select,
.modal-content,
.list-group-item,
.input-group-text {
  border-color: var(--border-color);
}
</style>
